import { CALL_API } from '../middleware/api'

export const BOWLER_REQUEST = 'BOWLER_REQUEST'
export const BOWLER_SUCCESS = 'BOWLER_SUCCESS'
export const BOWLER_FAILURE = 'BOWLER_FAILURE'

export function fetchBowler(startDate, endDate) {
  let params = ''
  if (startDate && endDate) {
    params = `StartDate=${startDate}&EndDate=${endDate}`
  }
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `bowler${params ? '?' + params : ''}`,
      authenticated: true,
      types: [BOWLER_REQUEST, BOWLER_SUCCESS, BOWLER_FAILURE],
    },
  }
}
